import React from 'react';
import configImages from '../../../../config/configImages';
import VerifyAuthenticator from './Verify-Authenticator';

const VerifyGoogleAuthenticator = () => (
    <div>
        <div className='common-login-container'>
            <div className='login1' style={{ width: '30rem' }}>
                <div className='card'>
                    <div className='card-body'>
                        <div className='text-center w-100'>
                            <img src={configImages.loginImage} className='login-logo'></img>
                        </div>
                        <VerifyAuthenticator onSubmit />
                    </div >
                </div >
            </div >
        </div >

    </div >
);

export default VerifyGoogleAuthenticator;
